import React, { useEffect } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { FAQSection } from '@/components/sections/FAQSection';
import { SmartFAQSearch } from '@/components/ai/SmartFAQSearch';
import { Sparkles } from 'lucide-react';

const FAQPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-24">
        {/* Page Header */}
        <section className="py-12 lg:py-16 bg-background">
          <div className="section-container">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                Frequently Asked Questions
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Find answers to common questions about car finance claims, or use our AI assistant for instant help.
              </p>
            </div>
          </div>
        </section>

        {/* AI-Powered FAQ Section */}
        <section id="ask-ai" className="py-16 lg:py-20 bg-muted/30">
          <div className="section-container">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-gold bg-gold/10 px-4 py-2 rounded-full mb-4">
                <Sparkles className="w-4 h-4" />
                AI-Powered FAQ
              </span>
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-foreground mb-4">
                Ask Our AI
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Get instant answers to your questions about car finance claims.
              </p>
            </div>
            <SmartFAQSearch />
          </div>
        </section>

        {/* Static FAQ Section */}
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
